import axios from 'axios';
import { find } from 'lodash';

export default {
    namespaced: true,
    state: {
        all: [],
    },
    getters: {
        getAll(state) {
            return state.all;
        },
        getByFlangeSizeAndPumpGroup: (state) => (flangeSize, pumpGroupId) => {
            return find(state.all, lanternPiece => {
                const flangeSizeMatches = lanternPiece.flange_size === flangeSize;
                const pumpGroupMatches = lanternPiece.pump_group_id === pumpGroupId;

                return flangeSizeMatches && pumpGroupMatches;
            });
        },
        getLanternPiecesByFlangeSize: (state) => (flangeSize) => {
            let allMatchedLanternPieces = _.filter(state.all, lanternPiece => {
                return lanternPiece.flange_size === flangeSize;
            })

            if (allMatchedLanternPieces) {
                return allMatchedLanternPieces;
            }
        }
    },
    actions: {
        index({ commit }) {
            return axios.get(process.env.VUE_APP_API_URL + 'lantern_pieces')
                .then(({ data }) => {
                    commit('setLanterns', data);
                });
        },
    },
    mutations: {
        setLanterns(state, lanterns) {
            state.all = lanterns;
        },
    },
};
